import { Injectable } from '@angular/core';
import { DwoCheckListGroupItemMappingViewModel } from '../business-entities/dwo-check-list-group-item-mapping-view-model';
import { AddCheckListRequestModel } from '../business-entities/dwo-check-list-group-mapping-view-model';
import { DwoCheckListRequestModel } from '../business-entities/dwo-check-list-request-model';
import { DwoSubCheckListDetailViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { VehicleType } from './../business-entities/vehicleTypes-model';
@Injectable({
  providedIn: 'root'
})
export class CheckListDataService {

  constructor(private dataService: DataService) { }

  getCheckList(param: DwoCheckListRequestModel): Promise<GenericResponse<DwoSubCheckListDetailViewModel>> {
    return this.dataService.Post<GenericResponse<DwoSubCheckListDetailViewModel>>(Urls.GetCheckList, param).toPromise();
  }

  addCheckList(param: AddCheckListRequestModel): Promise<GenericResponse<any>>{
    return this.dataService.Post<GenericResponse<any>>(Urls.AddCheckList, param).toPromise();
  }

  addCheckListItem(param: DwoCheckListGroupItemMappingViewModel): Promise<GenericResponse<any>>{
    return this.dataService.Post<GenericResponse<any>>(Urls.AddCheckListItem, param).toPromise();
  }

  deleteCheckList(param: any){
    return this.dataService.Post<GenericResponse<any>>(Urls.DeleteCheckList, param).toPromise();
  }

  getCheckListByMappingId(model:any){
    return this.dataService.Post<GenericResponse<any>>(Urls.GetCheckListByMappingId, model).toPromise();
  }

  updateCheckList(model:any){
    return this.dataService.Post<GenericResponse<any>>(Urls.UpdateCheckList, model).toPromise();
  }

  createDuplicateCheckList(model:any){
    return this.dataService.Post<GenericResponse<any>>(Urls.CreateDuplicateCheckList, model).toPromise();
  }

  updateCheckListItems(model:any)
  {
    return this.dataService.Put<GenericResponse<any>>(Urls.UpdateCheckListItem, model).toPromise();
  }
  getCheckListItemsByMappingId(mappingiId:any){
    return this.dataService.Get<GenericResponse<any>>(Urls.GetCheckListItemsByMappingId, mappingiId).toPromise();
  }
  getColorCheckListItemsByMappingId(mappingiId:any){
    return this.dataService.Get<GenericResponse<any>>(Urls.GetColorCheckListItemsByMappingId, mappingiId).toPromise();
  }
  getVehicleTypes()
  {
    return this.dataService.Get<GenericResponse<Array<VehicleType>>>(Urls.GetVehicleType).toPromise();
  }
}
